





























import { Component, Vue } from "vue-property-decorator";
import { deletePost } from "@/services/posts/postsService";

@Component
export default class PostDeleteModal extends Vue {
    itemToBeDeleted: string = "";
    itemName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(postId: string, name: string) {
        this.itemToBeDeleted = postId;
        this.itemName = name;
        this.$bvModal.show("modal-deletePost");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deletePost");
        this.itemToBeDeleted = "";
        this.itemName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deletePost(this.itemToBeDeleted).then(() => {
            this.$emit("reload");
            this.itemToBeDeleted = "";
            this.itemName = "";
            this.$bvModal.hide("modal-deletePost");
        });
    }
}
